import * as https from 'https'
import { z } from 'zod'

import { httpGet } from '../trials/http'
import { AuthenticationService } from './services/authenticationService'

const SAML_SERVICE = process.env.NEXT_PUBLIC_SAML_SERVICE ?? ''
const MAIN_DOMAIN = process.env.NEXT_PUBLIC_MAIN_DOMAIN ?? ''

if (SAML_SERVICE.length === 0) {
	console.error('SAML_SERVICE needs to be set')
}

if (MAIN_DOMAIN.length === 0) {
	console.error('MAIN_DOMAIN needs to be set')
}

export const JwtResponseSchema = z.object({
	jwt: z.string()
})
export type JwtResponse = z.infer<typeof JwtResponseSchema>

export const JwtRequestSchema = z.object({
	authCode: z.string()
})
export type JwtRequest = z.infer<typeof JwtRequestSchema>

export const AuthCodeExchangeResponseSchema = z.object({
	jwt: z.string(),
	emailAddress: z.string()
})
export type AuthCodeExchangeResponse = z.infer<typeof AuthCodeExchangeResponseSchema>

export const authCodeExchange = async (request: JwtRequest): Promise<AuthCodeExchangeResponse> => {
	const authenticationService = new AuthenticationService()

	return exchangeAuthCode(request.authCode).then((response) => {
		authenticationService.setCookie(response.jwt)
		const sessionCookie = authenticationService.getSessionCookie()

		return {
			jwt: response.jwt,
			emailAddress: sessionCookie.email ?? ''
		}
	})
}

async function exchangeAuthCode(authCode: string): Promise<JwtResponse> {
	const httpsAgent = new https.Agent({
		rejectUnauthorized: false
	})

	return httpGet<JwtResponse>(`${SAML_SERVICE}/saml_jwt?auth_code=${authCode}`, {
		headers: {
			Referer: MAIN_DOMAIN,
			'X-Auth-Jwt': authCode
		},
		agent: httpsAgent
	})
}
